module.exports = __webpack_public_path__ + "static/media/palm.10ca23f0.svg";